import { dateFormat, formatDate, computeHealthPriority } from '../utils.js';

class Serializer {
  normalize = data => {
    if(!data.node){
      return {}
    }

    return {
      id: data.node.nodeAddress,
      health: data.health,
      nodeAddress: data.node.nodeAddress,
      name: data.node.nodeName,
      gateway: data.properties.gateway,
      referencePointsCount: data.properties.referencePointsCount,
      tagsCount: data.properties.tagsCount,
      siteId: data.node.assetInfo.metadata.props && data.node.assetInfo.metadata.props.siteId,
      lastSeenAt: formatDate(data.properties.lastSeenAt, dateFormat),
      healthPriority: computeHealthPriority(data.health)
    };
  };
}

export const AccessPointSerializer = new Serializer();



// WEBPACK FOOTER //
// ./src/models/status/accesspoint/index.js